module.exports = __webpack_public_path__ + "static/media/carousel-image-two.2019c91e.png";